import { GET_BOOKING_DETAILS } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case GET_BOOKING_DETAILS:
      return action.payload;
    default:
      return state;
  }
};
